import { useState } from "react";
import { useSelector } from "react-redux";
import PageHeader from "../../Component/Common/PageHeader";
import MultiButton from "../../Component/extra/MultiButton";
import ManageUser from "./ManageUser";
import UserSetting from "./UserSetting";
import FakeUser from "./FakeUser";
import NewFakeUser from "../../Component/dialogue/NewFakeUser";
import dayjs from "dayjs";

const TabsName = {
  Tab1: "User",
  Tab2: "Fake User",
};

export default function UserPage() {
  const { dialogueType } = useSelector((state) => state.dialogue);

  const [currentTab, setCurrentTab] = useState(TabsName.Tab1);
  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");

  const startDateFormat = (startDate) => {
    return startDate && dayjs(startDate).isValid()
      ? dayjs(startDate).format("YYYY-MM-DD")
      : "All";
  };
  const endDateFormat = (endDate) => {
    return endDate && dayjs(endDate).isValid()
      ? dayjs(endDate).format("YYYY-MM-DD")
      : "All";
  };

  const startDateData = startDateFormat(startDate);
  const endDateData = endDateFormat(endDate);

  return (
    <div className="userPage">
      <div
        style={{
          display: `${
            dialogueType === "manageUser"
              ? "none"
              : dialogueType === "hostSettleMent"
                ? "none"
                : dialogueType === "hostHistory"
                  ? "none"
                  : dialogueType === "fakeUserAdd"
                    ? "none"
                    : dialogueType === "hostReport"
                      ? "none"
                      : "block"
          }`,
        }}
      >
        <PageHeader
          heading={"Welcome Admin"}
          subHeading="User"
          showDateRange={true}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />

        <MultiButton
          label={Object.values(TabsName)}
          multiButtonSelect={currentTab}
          setMultiButtonSelect={setCurrentTab}
        />

        {currentTab == TabsName.Tab1 && (
          <ManageUser
            endDate={endDateData}
            startDate={startDateData}
            multiButtonSelectNavigate={setCurrentTab}
          />
        )}
        {currentTab == TabsName.Tab2 && (
          <FakeUser endDate={endDateData} startDate={startDateData} />
        )}
      </div>

      {dialogueType == "manageUser" && (
        <UserSetting
          multiButtonSelectNavigate={currentTab}
          multiButtonSelectNavigateSet={setCurrentTab}
        />
      )}
      {dialogueType == "fakeUserAdd" && <NewFakeUser />}
    </div>
  );
}
